import { colors } from '../../../theme/colors'

/** Tick values: Figma 4640:2904 / 2916 `presets.neutral.100`. */
const tickLabelFillLight = colors.presets.neutral['100']
/** Axis titles: Figma 4640:2927 / 2995 `presets.turquoise.100`. */
const axisLabelFillLight = colors.presets.turquoise['100']
const chartFontFamily = 'Montserrat, sans-serif'

export const ChartAxisConstants = {
  defaultShowXAxisTicks: false,
  defaultShowYAxisTicks: false,
  defaultShowXAxisLine: true,
  defaultShowYAxisLine: true,
  defaultXAxisIsDate: false,
  defaultShowDataLabels: false,
  defaultAxisTickLabelLayout: 'horizontal' as const,
  defaultAxisTickLabelTruncation: 20,
  /** Small mark drawn from the axis baseline when tick marks are enabled. */
  axisTickLength: 4,
  /** Gap from Y-axis line to tick values (Figma ~7px). */
  yTickMargin: 7,
  /** Gap between X-axis line and dimension tick labels (Figma ~5px). */
  xTickMargin: 5,
  /** Gap between X tick labels and the axis title (Figma ~12–13px). */
  xLabelGap: 12,
  /** Gap between Y tick values and the rotated axis title (Figma ~11px). */
  yLabelGap: 12,
  dataLabelOffsetY: 8,
  /** Gap from the bar end to the value label (horizontal bars). */
  dataLabelOffsetX: 8,
  axisStrokeWidth: 1,
  fontFamily: chartFontFamily,
  /** Axis line (1px solid border along the labeled sides). */
  axisStroke: {
    light: colors.presets.turquoise['100'],
    /** Match tick text in dark mode. */
    dark: colors.presets.neutral['0'],
  },
  tickLabel: {
    fill: tickLabelFillLight,
    fontFamily: chartFontFamily,
    fontSize: 10,
    fontWeight: 500,
  } as const,
  tickLabelFillDark: colors.presets.neutral['0'],
  axisLabel: {
    fill: axisLabelFillLight,
    fontFamily: chartFontFamily,
    fontSize: 10,
    fontWeight: 500,
    textAnchor: 'middle' as const,
  },
  axisLabelFillDark: colors.presets.neutral['0'],
  dataLabel: {
    fill: tickLabelFillLight,
    fontFamily: chartFontFamily,
    fontSize: 10,
    fontWeight: 600,
    textAnchor: 'middle' as const,
  },
}

export const ChartAxisStyles = {
  tickLabel: ChartAxisConstants.tickLabel,
  axisLabel: ChartAxisConstants.axisLabel,
  dataLabel: ChartAxisConstants.dataLabel,
  axisStrokeWidth: ChartAxisConstants.axisStrokeWidth,
}
